import {SELECT_MATRIX, SET_MATRICES, MATRIX_LOADED, MATRIX_COLLAPSE_TOGGLE} from "../../actions/MatrixActions";

const initialState = {
    matrices: {},
    selected: {},
    selectedDepartureCity: '',
    loading: false,
    isMatrixCollapsed: false,
};

const MatrixReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MATRICES:
            return {...state, matrices: action.matrices};
        case SELECT_MATRIX:
            return {...state, selected: state.matrices[action.city], selectedDepartureCity: action.city, loading: true};
        case MATRIX_LOADED:
            return {...state, loading: false};
        case MATRIX_COLLAPSE_TOGGLE:
            return {...state, isMatrixCollapsed: !state.isMatrixCollapsed};
        default:
            return state;
    }
};

export default MatrixReducer;



// WEBPACK FOOTER //
// ./src/reducers/matrix/MatrixReducer.js